<div class="tr-page">
  <app-project-nav></app-project-nav>

  <app-page-header
    size="compact"
    [title]="'testResults.pageTitle' | translate"
    [subtitle]="'testResults.pageSubtitle' | translate"
  >
    <ng-container right>
      <div class="tr-controls">
        @if (view() !== 'freigabe') {
          <app-search-bar
            class="tr-search"
            data-testid="ergebnis-suche"
            [placeholder]="'testResults.toolbar.suche.' + view() | translate"
            [value]="suche()"
            (valueChange)="onSucheChange($event)"
          />
        }
        @if (releases().length > 0) {
          <select
            class="tr-select tr-select--aktiv"
            #releaseSelect
            data-testid="release-select"
            [attr.aria-label]="'testResults.toolbar.release' | translate"
            (change)="onReleaseSelected(releaseSelect)"
          >
            @for (r of releases(); track r.id) {
              <option [value]="r.id" [selected]="r.id === selectedReleaseId()">{{ r.label }}</option>
            }
          </select>
        }
        <select
          class="tr-select"
          [class.tr-select--aktiv]="aktiveStufe()"
          data-testid="tr-teststufe"
          [attr.aria-label]="'testResults.toolbar.stufe' | translate"
          (change)="onStufeSelected($any($event.target).value)"
        >
          <option value="" [selected]="!aktiveStufe() && !umgebungOhneStufe()">
            {{ 'testResults.toolbar.alleStufen' | translate }}
          </option>
          @if (umgebungOhneStufe(); as umgebung) {
            <option [value]="umgebungOhneStufeOption" selected>
              {{ 'testResults.toolbar.alleStufen' | translate }} · {{ umgebung }}
            </option>
          }
          @for (s of stufen(); track s.name) {
            <option [value]="s.name" [selected]="s.name === aktiveStufe()?.name">
              {{ s.name }} · {{ s.umgebung }}
            </option>
          }
        </select>
        @if (umgebung(); as wert) {
          <span
            class="tr-umgebung-chip"
            data-testid="tr-umgebung-chip"
            [attr.title]="
              aktiveStufe()
                ? ('testResults.toolbar.umgebungTooltip' | translate: { stufe: aktiveStufe()?.name, umgebung: wert })
                : null
            "
          >
            {{ 'testResults.toolbar.umgebungChip' | translate }}
            <strong>{{ wert }}</strong>
          </span>
        }
        <!-- Rollout NEX-788: geteilter Ansichten-Baustein aus NEX-786 (page-testresultate.jsx:228-230). -->
        <app-saved-views-menu
          [views]="savedViewsOptions()"
          [activeName]="activeSavedViewName()"
          [context]="'TEST_RESULTS'"
          [projectId]="projectId"
          (viewSelected)="onSavedViewSelected($event)"
          (viewSaved)="onSavedViewSaved($event)"
          (viewDeleted)="onSavedViewDeleted($event)"
          (viewDeleteFailed)="onSavedViewDeleteFailed()"
        />
        @if (!isReadOnly()) {
          <button
            type="button"
            class="tr-secondary-btn tr-import-btn"
            data-testid="results-import"
            (click)="openUpload()"
          >
            <span class="tr-secondary-btn__glyph" aria-hidden="true">↑</span>
            {{ 'testResults.toolbar.import' | translate }}
          </button>
        }
        <button
          type="button"
          class="tr-secondary-btn"
          data-testid="report-open"
          [disabled]="!selectedRelease()"
          (click)="reportOpen.set(true)"
        >
          <span class="tr-secondary-btn__glyph" aria-hidden="true">↓</span>
          {{ 'testResults.toolbar.report' | translate }}
        </button>
        <span
          class="tr-pin-tip"
          data-testid="tr-aufs-dashboard-tip"
          [matTooltip]="(isPinned() ? 'testResults.pin.addedTooltip' : 'testResults.pin.addTooltip') | translate"
        >
          <button
            type="button"
            class="tr-secondary-btn"
            data-testid="tr-aufs-dashboard"
            [disabled]="!canPin()"
            (click)="pinToDashboard()"
          >
            <span class="tr-secondary-btn__glyph" aria-hidden="true">{{ isPinned() ? '✓' : '＋' }}</span>
            {{ (isPinned() ? 'testResults.pin.added' : 'testResults.pin.add') | translate }}
          </button>
        </span>
      </div>
    </ng-container>
  </app-page-header>

  @if (savedViewsError()) {
    <p class="tr-hint tr-hint--error" role="alert">{{ savedViewsError() }}</p>
  }

  <div class="tr-view-bar">
    <app-segmented-filter-control
      variant="tabs"
      idPrefix="tr-view-tab"
      controls="tr-view-panel"
      [items]="viewItems()"
      [value]="view()"
      [ariaLabel]="'testResults.views.ariaLabel' | translate"
      (valueChange)="setView($event)"
    />
    <span class="tr-view-hint">{{ 'testResults.views.' + view() + '.hint' | translate }}</span>
  </div>

  <div class="tr-view-panel" id="tr-view-panel" role="tabpanel" [attr.aria-labelledby]="'tr-view-tab-' + view()">
    @if (view() === 'freigabe') {
      <app-release-freigabe
        [projectId]="projectId"
        [releases]="releases()"
        [releaseId]="selectedReleaseId()"
        [releasesState]="releasesState()"
        [environment]="umgebung()"
        [aktualisierung]="aktualisierung()"
        (releasesNeuLaden)="loadReleasesAgain()"
        (protokollExportieren)="reportOpen.set(true)"
      />
    } @else if (view() === 'plaene') {
      <app-plan-ergebnis-tabelle
        [projectId]="projectId"
        [releaseId]="selectedReleaseId()"
        [releasesState]="releasesState()"
        [environment]="umgebung()"
        [planKey]="planFilter()"
        [suche]="suche()"
        [aktualisierung]="aktualisierung()"
        (laeufeOeffnen)="openPlanLaeufe($event)"
        (releasesNeuLaden)="loadReleasesAgain()"
      />
    } @else if (view() === 'laeufe') {
      <app-lauf-ergebnis-tabelle
        [projectId]="projectId"
        [releaseId]="selectedReleaseId()"
        [releasesState]="releasesState()"
        [environment]="umgebung()"
        [planKey]="planFilter()"
        [suche]="suche()"
        [aktualisierung]="aktualisierung()"
        (alleLaeufe)="clearPlanFilter()"
        (releasesNeuLaden)="loadReleasesAgain()"
      />
    } @else if (loading()) {
      <div class="tr-state">
        <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
      </div>
    } @else if (loadError()) {
      <div class="tr-state tr-state--error" role="alert">
        <span>{{ 'testResults.loadError' | translate }}</span>
        <button type="button" class="tr-secondary-btn" data-testid="testfaelle-retry" (click)="reload()">
          {{ 'common.retry' | translate }}
        </button>
      </div>
    } @else {
      <div class="tr-kpis">
        <div class="tr-kpi tr-kpi--rate">
          <div class="tr-kpi-top">
            <div>
              <div class="tr-kpi-label">{{ 'testResults.kpi.passRate' | translate }}</div>
              <div class="tr-kpi-value">{{ passRate() }}%</div>
            </div>
            <app-sparkline
              [data]="trend()"
              colorVar="--to-green-dot"
              [width]="120"
              [height]="44"
              [ariaLabel]="'testResults.kpi.passRate' | translate"
            />
          </div>
          <div class="tr-bar">
            <span class="tr-bar-seg tr-bar-seg--passed" [style.width.%]="barWidths().passed"></span>
            <span class="tr-bar-seg tr-bar-seg--failed" [style.width.%]="barWidths().failed"></span>
            <span class="tr-bar-seg tr-bar-seg--open" [style.width.%]="barWidths().openSkipped"></span>
          </div>
        </div>

        <div class="tr-kpi">
          <div class="tr-kpi-icon tr-kpi-icon--neutral"><mat-icon>bar_chart</mat-icon></div>
          <div class="tr-kpi-label">{{ 'testResults.kpi.executed' | translate }}</div>
          <div class="tr-kpi-value tr-kpi-value--neutral">{{ executed() }}</div>
        </div>
        <div class="tr-kpi">
          <div class="tr-kpi-icon tr-kpi-icon--failed"><mat-icon>close</mat-icon></div>
          <div class="tr-kpi-label">{{ 'testResults.kpi.failed' | translate }}</div>
          <div class="tr-kpi-value tr-kpi-value--failed">{{ failed() }}</div>
        </div>
        <div class="tr-kpi">
          <div class="tr-kpi-icon tr-kpi-icon--open"><mat-icon>shield</mat-icon></div>
          <div class="tr-kpi-label">{{ 'testResults.kpi.openSkipped' | translate }}</div>
          <div class="tr-kpi-value tr-kpi-value--open">{{ openSkipped() }}</div>
        </div>
      </div>

      <div class="tr-filters">
        @for (chip of filterChips(); track chip.id) {
          <app-filter-chip
            [label]="chip.labelKey | translate"
            [count]="chip.count"
            [active]="resultFilter() === chip.id"
            [pill]="true"
            (clicked)="setResult(chip.id)"
          />
        }
        <span class="tr-filters-spacer"></span>
        <span class="tr-history-hint">{{ 'testResults.historyHint' | translate }}</span>
      </div>

      <div class="tr-table-card" [class.tr-table-card--busy]="refetching()" [attr.aria-busy]="refetching() || null">
        <div class="tr-table-head">
          <div class="tr-col-key">{{ 'testResults.table.testCase' | translate }}</div>
          <div class="tr-col-title">{{ 'testResults.table.title' | translate }}</div>
          <div class="tr-col-system">{{ 'testResults.table.source' | translate }}</div>
          <div class="tr-col-env">{{ 'testResults.table.environment' | translate }}</div>
          <div class="tr-col-history">{{ 'testResults.table.history' | translate }}</div>
          <div class="tr-col-duration">{{ 'testResults.table.duration' | translate }}</div>
          <div class="tr-col-defects">{{ 'testResults.table.defects' | translate }}</div>
          <div class="tr-col-result">{{ 'testResults.table.lastResult' | translate }}</div>
          <div class="tr-col-chevron"></div>
        </div>

        @if (rows().length === 0) {
          <div class="tr-empty">{{ 'testResults.empty' | translate }}</div>
        }

        @for (row of rows(); track row.testCaseId) {
          <a
            class="tr-row"
            [attr.data-testid]="'test-results-row-' + row.testCaseId"
            [class.tr-row--deferred]="isDeferred(row)"
            [routerLink]="rowLink(row)"
            [attr.aria-label]="rowAriaLabel(row)"
            [attr.aria-describedby]="defectsDescriptionId(row)"
            [attr.aria-disabled]="isDeferred(row) ? 'true' : null"
            [attr.title]="isDeferred(row) ? ('testResults.deferredRowTitle' | translate) : null"
          >
            <div class="tr-col-key">
              @if (row.testCaseKey) {
                <app-code-id-chip [id]="row.testCaseKey" />
              } @else {
                <span class="tr-env-empty">—</span>
              }
            </div>
            <div class="tr-col-title tr-title-cell">{{ row.title }}</div>
            <div class="tr-col-system">
              <app-system-badge
                [kind]="sourceToSystemKey(row.source)"
                [label]="systemMeta(sourceToSystemKey(row.source)).labelKey | translate"
                size="sm"
              />
            </div>
            <div class="tr-col-env">
              @if (row.environment) {
                <app-umgebung-pill [umgebung]="row.environment" [isBranch]="isBranchEnvironment(row.source)" />
              } @else {
                <span class="tr-env-empty">—</span>
              }
            </div>
            <div class="tr-col-history tr-history">
              @for (h of row.history; track $index) {
                <app-matrix-cell
                  [status]="matrixStatus(h)"
                  [tooltip]="'testResults.result.' + statusKey(h) | translate"
                />
              }
            </div>
            <div class="tr-col-duration">{{ formatDuration(row.durationSeconds) }}</div>
            <div class="tr-col-defects tr-defects">
              @for (d of visibleDefects(row); track d.key) {
                <span class="tr-defect-key" [title]="'testResults.defects.linkedBug' | translate">
                  @if (d.blocking) {
                    <span aria-hidden="true">⛔</span>
                  }
                  {{ d.key }}
                </span>
              } @empty {
                <span class="tr-env-empty">—</span>
              }
              @let hidden = hiddenDefects(row);
              @if (hidden.length) {
                <span
                  class="tr-defect-more"
                  aria-hidden="true"
                  [title]="'testResults.defects.more' | translate: { keys: defectKeys(hidden) }"
                >
                  +{{ hidden.length }}
                </span>
              }
              <span class="tr-sr-only" [id]="defectsDescriptionId(row)">{{ defectsDescription(row) }}</span>
            </div>
            <div class="tr-col-result">
              <app-res-pill
                [status]="resPillStatus(row.lastResult)"
                [label]="'testResults.result.' + statusKey(row.lastResult) | translate"
              />
            </div>
            <div class="tr-col-chevron">
              @if (isDeferred(row)) {
                <span class="tr-later">{{ 'testResults.laterBadge' | translate }}</span>
              } @else {
                <mat-icon>chevron_right</mat-icon>
              }
            </div>
            @if (isDeferred(row)) {
              <span class="tr-sr-only">{{ 'testResults.deferredRowTitle' | translate }}</span>
            }
          </a>
        }
      </div>

      <div class="tr-footer">
        <span class="tr-footer__range" role="status">
          {{
            'testResults.footer.rangeLabel'
              | translate: { start: rangeStart(), end: rangeEnd(), total: totalElements() }
          }}
        </span>
        <div class="tr-footer__pager">
          <label class="tr-footer__label" for="tr-page-size">{{ 'testResults.footer.rowsPerPage' | translate }}</label>
          <select
            id="tr-page-size"
            class="tr-footer__select"
            (change)="onPageSizeChange(+pageSizeSelect.value)"
            #pageSizeSelect
            [attr.aria-label]="'testResults.footer.rowsPerPageAriaLabel' | translate"
          >
            @for (size of pageSizeOptions; track size) {
              <option [value]="size" [selected]="pageSize() === size">{{ size }}</option>
            }
          </select>
          @if (pageCount() > 1) {
            <div class="tr-footer__nav">
              <button
                type="button"
                class="tr-action-btn"
                [disabled]="pageIndex() === 0"
                [attr.aria-label]="'testResults.footer.previousPage' | translate"
                (click)="onPageChange(pageIndex() - 1)"
              >
                <mat-icon aria-hidden="true">chevron_left</mat-icon>
              </button>
              <button
                type="button"
                class="tr-action-btn"
                [disabled]="pageIndex() >= pageCount() - 1"
                [attr.aria-label]="'testResults.footer.nextPage' | translate"
                (click)="onPageChange(pageIndex() + 1)"
              >
                <mat-icon aria-hidden="true">chevron_right</mat-icon>
              </button>
            </div>
          }
        </div>
      </div>
    }
  </div>

  <lib-modal
    [closeLabel]="'general.close' | translate"
    [title]="'common.unsavedChanges.title' | translate"
    [text]="'common.unsavedChanges.message' | translate"
    [visible]="showDeactivateConfirm()"
    [saveText]="'common.unsavedChanges.leave' | translate"
    [cancelText]="'common.unsavedChanges.stay' | translate"
    (save)="onDeactivateConfirmed()"
    (cancel)="onDeactivateCancelled()"
    (visibleChange)="!$event && onDeactivateCancelled()"
  ></lib-modal>

  @if (selectedRelease(); as rel) {
    <app-report-modal
      [projectId]="projectId"
      [releaseId]="rel.id"
      [releaseLabel]="rel.label"
      [initialArt]="view() === 'freigabe' ? 'ABSCHLUSS' : null"
      [initialPlan]="view() === 'laeufe' ? planFilter() : null"
      [canSaveVersion]="!isReadOnly()"
      [stufen]="stufen()"
      [initialStufe]="aktiveStufe()?.name ?? null"
      [(visible)]="reportOpen"
    />
  }

  <app-testresultat-import-dialog
    [projectId]="projectId"
    [release]="selectedRelease()"
    [(visible)]="showUploadModal"
    (imported)="onImported($event)"
  />
</div>
